module.exports = __webpack_public_path__ + "img/danger.ee37dd50.svg";